var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "changelog-delta" }, [
    _vm.changes.length > 0
      ? _c("div", { staticClass: "p-l-5 f-s-12" }, [
          _c(
            "ul",
            { staticClass: "changelog-delta-list" },
            [
              _c("ChangeUpdateChanges", {
                attrs: { changes: _vm.changes, code: _vm.code }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }